/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardedUser } from '../../models/onboarded-user';

export interface GetAllSubscriptionOnboardedUsers$Params {

/**
 * The subscription uid
 */
  subscriptionUid: string;
}

export function getAllSubscriptionOnboardedUsers(http: HttpClient, rootUrl: string, params: GetAllSubscriptionOnboardedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardedUser>>> {
  const rb = new RequestBuilder(rootUrl, getAllSubscriptionOnboardedUsers.PATH, 'get');
  if (params) {
    rb.path('subscriptionUid', params.subscriptionUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OnboardedUser>>;
    })
  );
}

getAllSubscriptionOnboardedUsers.PATH = '/custom/onboarding/subscription/{subscriptionUid}/users';
